(function () {
	window.addEventListener("hashchange", function () {
        window.scrollTo(window.scrollX, window.scrollY - 120);
    });	
	jQuery('#branchFilter').on('change', function() {
		var clicked = jQuery('#branchFilter').val().toLowerCase();
		location.href = '#' + clicked;
	});
})();